<script setup lang="ts">
import { useApplicationStore } from "../stores/application";

const applicationStore = useApplicationStore();

</script>
<template>
    <div class="d-flex">
        <div class="col-12 mt-4">
            <div class="card">
                <div class="card-header-1">
                    <div class="line-height-intro">
                        Information
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body-new">
                    <div class="row">
                        <span>
                            You've reviewed your quotes and are almost ready to apply for your chosen annuity. On this page
                            we'll let you know what you'll need to complete your application.
                            <br><br>Annuity Ready do not provide financial advice. So, it is imperative that you have
                            considered all your options and decided this is the best option for you.
                            Annuity Ready provide quotes on a non-advised basis. This means we do not offer advice and you
                            are solely responsible for deciding if the policy is right for you.
                            You can get guidance from the government's free and impartial service <a
                                id="pension-link"
                                href="https://www.pensionwise.gov.uk/en"
                                target="_blank"
                            >Pension Wise</a>.
                            If you need advice, we recommend you speak to a financial adviser.
                        </span>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header-1">
                    <div class="line-height-intro">
                        Things to be aware of
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body-new">
                    <div class="row">
                        <div>
                            Once the cancellation period has passed:<ul>
                                <li class="pt-2">
                                    Your plan is payable for the rest of your life and any named joint
                                    annuitant's life, depending on the plan you have chosen.
                                </li>
                                <li class="pt-2">
                                    You will not be able to cash it in, change it or cancel it.
                                </li>
                            </ul>
                            <p class="pt-2">
                                Please refer to the providers key features and terms & conditions documents for
                                more information.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header-1">
                    <div class="line-height-intro">
                        Important documents you should read
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body-new">
                    <div class="row">
                        <span>Before continuing please read the following documents. These are personal to you
                            and detail the product you are going to apply for. Please read them carefully before continuing
                            to the application:
                        </span>
                        <div class="col-12 mt-3">
                            <p>
                                <a
                                    target="_blank"
                                    :href="`/documents/${applicationStore.quoteNumber}/${applicationStore.premiumId}/keyfacts`"
                                    class="mt-2 download"
                                >Quote (Key facts)</a> - Outlining your choices and annuity amount.
                            </p>
                        </div>
                        <div class="col-12 pt-2">
                            <p>
                                <a
                                    target="_blank"
                                    :href="applicationStore.keyFeaturesUrl"
                                    class="mt-2 download"
                                >Key features</a> - Outlining the product’s aims, risks, benefits and providing helpful information.
                            </p>
                        </div>
                        <div class="col-12 pt-2">
                            <p>
                                <a
                                    target="_blank"
                                    :href="applicationStore.termsConditionsUrl"
                                    class="mt-2 download"
                                >
                                    Terms &amp; conditions
                                </a>
                            </p>
                        </div>
                        <div class="col-12 pt-2">
                            <p>
                                <a
                                    target="_blank"
                                    :href="applicationStore.privacyUrl"
                                    class="mt-2 download"
                                >
                                    Privacy Notice
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="row">
                    <div>
                        By clicking ‘Continue to apply’ you confirm you:
                        <ul>
                            <li class="pt-2">
                                Have read and understood the documents above
                            </li>
                            <li class="pt-2">
                                Are happy to continue to the application form
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
#pension-link:not(:hover) {
    text-decoration: none;
}
</style>
